import React from 'react';

export default function AboutSection() {
  return (
    <div id="about">
      <div className="ab-grid">
        <div className="ab-l rl">
          <div className="kicker k-gold">Who We Are</div>
          <h2>
            Precision
            <br />
            <em>chemistry.</em>
            <br />
            Infinite
            <br />
            possibility.
          </h2>
          <p>
            Auralux is a technology-driven masterbatch and additive company dedicated to empowering manufacturers with
            color brilliance, functional performance, and sustainable chemistry across 50+ countries.
          </p>
          <div className="pillars">
            <div className="pillar">
              <div className="p-ic">⚗️</div>
              <h4>R&amp;D Excellence</h4>
              <p>State-of-the-art polymer labs with expert chemists developing next-generation formulations daily.</p>
            </div>
            <div className="pillar">
              <div className="p-ic">🌿</div>
              <h4>Green Chemistry</h4>
              <p>Bio-based carriers, low-VOC pigments, and recyclability-compatible formulations at the core.</p>
            </div>
            <div className="pillar">
              <div className="p-ic">🎯</div>
              <h4>Custom Precision</h4>
              <p>Application-engineered formulations with ΔE &lt; 0.5 and true batch-to-batch consistency.</p>
            </div>
            <div className="pillar">
              <div className="p-ic">🌐</div>
              <h4>Global Reach</h4>
              <p>Manufacturing and technical service spanning Asia, Middle East, Europe, and the Americas.</p>
            </div>
          </div>
        </div>
        <div className="ab-r rr">
          <div className="kicker" style={{ color: 'var(--green)' }}>
            <span
              style={{
                display: 'inline-block',
                width: 24,
                height: 1,
                background: 'var(--green)',
                verticalAlign: 'middle',
                marginRight: 12,
              }}
            />
            The Auralux Difference
          </div>
          <h2>
            Where polymer science meets <em>human purpose</em>
          </h2>
          <p>
            We don&apos;t simply manufacture masterbatch. We engineer partnerships built on technical depth, regulatory
            expertise, and an unwavering commitment to quality — from your first trial run to every production batch
            thereafter.
          </p>
          <p style={{ marginTop: 16 }}>
            Our formulations perform in blown film, injection molding, BOPET, medical packaging, automotive compounds,
            and agricultural films wherever demanding applications require no compromise on performance or compliance.
          </p>
          <div className="ab-nums">
            <div className="ab-n">
              <div className="ab-nv">45K</div>
              <div className="ab-nl">MT / Year Capacity</div>
            </div>
            <div className="ab-n">
              <div className="ab-nv">98.6%</div>
              <div className="ab-nl">Batch Consistency</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
